import { appApi } from './app_api';

export const customerManagersApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: (customerId) => `/customers/${customerId}/manager_permissions`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, customerId) => [{ type: 'Permissions', id: customerId }],
    }),
    getManager: builder.query({
      query: (phone) => `/users?phone=${encodeURIComponent(phone)}`,
      transformResponse: (response) => response.data,
    }),
    getManagers: builder.query({
      query: (customerId) => `/customers/${customerId}/managers`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, customerId) => [{ type: 'Managers', id: customerId }],
    }),
    addManager: builder.mutation({
      query: ({ customerId, manager }) => ({
        url: `/customers/${customerId}/add_manager`,
        method: 'POST',
        body: manager,
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Permissions', id: customerId }],
    }),
    removeManager: builder.mutation({
      query: ({ customerId, managerId }) => ({
        url: `/customers/${customerId}/remove_manager`,
        method: 'POST',
        body: { manager_id: managerId },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Permissions', id: customerId }],
    }),
    updateManagerPermissions: builder.mutation({
      query: ({ customerId, managerId, permission, value }) => ({
        url: `/customers/${customerId}/update_manager_permission`,
        method: 'PUT',
        body: {
          manager_id: managerId,
          permission,
          value,
        },
      }),
      invalidatesTags: (result, error, { customerId }) => [{ type: 'Permissions', id: customerId }],
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useLazyGetManagerQuery,
  useGetManagersQuery,
  useAddManagerMutation,
  useRemoveManagerMutation,
  useUpdateManagerPermissionsMutation,
} = customerManagersApi;
